import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './components/Main';


ReactDOM.render(<Routes />, document.getElementById('root')
);


